import React, { useMemo, useEffect, useState } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";
import { getLTAServices } from "common/services/ltas.service";
import { normalize } from "common/lib/normalize";

const FIELD = "ltaService";

/** The single service the agreement covers, drawn from the LTA Services data type. */
const SelectLTAService = ({ validation }: { validation: any }) => {
  const invalid = validation.touched[FIELD] && validation.errors[FIELD];

  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: invalid ? "red" : "#ced4da",
      "&:hover": { borderColor: invalid ? "red" : "#ced4da" },
    }),
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await getLTAServices({
          pagination: { page: 1, pageSize: 10000 },
          sort: ["name"],
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const options = useMemo(
    () => data.map((el: any) => ({ value: el?.id, label: el?.name })),
    [data]
  );

  return (
    <FormGroup className="mb-0">
      <Label htmlFor="ltaService-field" className="form-label">
        LTA Service
      </Label>
      <Select
        name={FIELD}
        id={FIELD}
        value={validation.values[FIELD]?.value ? validation.values[FIELD] : null}
        isSearchable
        isClearable
        placeholder="Select the service covered by this agreement"
        onChange={(value: any) => {
          validation.setFieldValue(FIELD, value || { value: "", label: "" });
          validation.setFieldError(FIELD, "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched(FIELD, true)}
        className={invalid ? "is-invalid" : ""}
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors[FIELD]?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectLTAService;
